import { Injectable } from "@angular/core";
import { BreadCrumb } from "../../models/common/bread-crumb";

@Injectable()
export class BreadcrumbService {
    breadcrumbs: BreadCrumb[] = [];

    setBreadcrumbs(breadcrumbs: BreadCrumb[]) {
        this.breadcrumbs = breadcrumbs || [];
    }
}
